import { isTurkishCoffeeItem } from './kitchenRoutes';

function money(n) {
  return Math.round(Number(n) * 100) / 100;
}

export function isKitchenEodDiscountOn(value) {
  return value === true || value === 1 || value === '1' || value === 'on';
}

export function isKitchenMenuItem(row) {
  if (!row) return false;
  if (Number(row.collected_at_counter) === 1) return false;
  if (isTurkishCoffeeItem(row)) return false;
  if (row.venue === 'desserts') return false;
  return row.venue !== 'cafe';
}

export function applyKitchenEodDiscount(unitPrice, row, enabled) {
  const n = Number(unitPrice);
  if (!Number.isFinite(n)) return 0;
  if (!enabled || !isKitchenMenuItem(row)) return money(n);
  return money(n * 0.5);
}
